import { Box, FormLabel } from '@chakra-ui/react';
import { Select } from 'chakra-react-select';
import CheckboxSelect from 'components/ui/CheckboxSelect/CheckboxSelect';
import FilterGroup from 'components/ui/FilterGroup';
import { ResourceSelect } from 'components/ui/ResourceCreatableSelect';
import { useResourceList } from 'hooks/useResourceList';
import { useEffect, useMemo } from 'react';
import { useFormContext } from 'react-hook-form';
import AnalyticsDateRange from './AnalyticsDateRange';

type EmailCategory = 'AGENDA' | 'REPORT' | 'NEWSLETTER';

const emailCategoryOptions: { label: string; value: EmailCategory }[] = [
  { label: 'Agenda', value: 'AGENDA' },
  { label: 'Report', value: 'REPORT' },
  { label: 'Newsletter', value: 'NEWSLETTER' },
];

export default function Filters() {
  const { control, setValue, watch } = useFormContext();

  const [
    selectedCompany,
    selectedEmailCategory,
    selectedContentGroups,
    selectedLists,
  ] = watch(['company', 'emailCategory', 'contentGroups', 'lists']);

  const { data: contentGroups } = useResourceList({
    resourceName: 'contentGroups',
    path: 'content-groups',
    params: {
      type: selectedEmailCategory?.value,
    },
  });

  const { data: lists } = useResourceList({
    resourceName: 'lists',
    path: 'lists',
    params: {
      ...(selectedCompany && { companyId: selectedCompany?.value }),
      contentGroupId: selectedContentGroups.map(
        (contentGroup) => contentGroup.value
      ),
    },
  });

  const contentGroupOptions = useMemo(
    () =>
      contentGroups?.map((contentGroup) => ({
        label: contentGroup.name,
        value: contentGroup.id,
      })),
    [contentGroups]
  );

  const listOptions = useMemo(
    () =>
      lists
        ?.map((list) => ({
          label: `${list.company.name} - ${list.name}`,
          value: list.id,
        }))
        .sort((a, b) => a.label.localeCompare(b.label)),
    [lists]
  );

  useEffect(() => {
    setValue('contentGroups', []);
  }, [selectedEmailCategory, setValue]);

  useEffect(() => {
    setValue('lists', []);
  }, [selectedContentGroups, setValue]);

  return (
    <FilterGroup>
      <Box minW="350px">
        <FormLabel>Filtrar por cliente</FormLabel>
        <ResourceSelect
          control={control}
          name="company"
          resourceKey="companies"
          listPath="/companies"
          placeholder="Todos os clientes"
          isClearable
        />
      </Box>

      <Box minW="250px">
        <FormLabel>Filtrar por período</FormLabel>
        <AnalyticsDateRange name="dateRange" control={control} />
      </Box>

      <Box minW="350px">
        <FormLabel>Filtrar por tipo</FormLabel>
        <Select
          onChange={(value) => setValue('emailCategory', value)}
          name="emailCategory"
          options={emailCategoryOptions}
          placeholder="Todos os tipos"
          isClearable
        />
      </Box>

      {selectedEmailCategory && (
        <Box minW="350px">
          <FormLabel>Filtrar por modelos de disparo</FormLabel>
          <CheckboxSelect
            name="contentGroups"
            placeholder="Todos os modelos"
            onChange={(value) => setValue('contentGroups', value)}
            value={selectedContentGroups}
            options={contentGroupOptions}
          />
        </Box>
      )}

      {selectedContentGroups.length > 0 && (
        <Box minW="350px">
          <FormLabel>Filtrar por listas de disparo</FormLabel>
          <CheckboxSelect
            name="lists"
            placeholder="Todas as listas"
            onChange={(value) => setValue('lists', value)}
            value={selectedLists}
            options={listOptions}
          />
        </Box>
      )}
    </FilterGroup>
  );
}
